<template>
  <div class="switch-regions">
    <HKLSelect
      v-model="selectedRegion"
      :options="regionOpts"
      @select="switchRegion"
    />
  </div>
</template>

<script>

import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { useStoreActions, useStoreGetters } from '@/store'
import { regionNames } from '@/utils/consts'
import i18n from '@/utils/i18n'
import { computed, onMounted, ref, unref } from 'vue-demi'
import { switchLangByRegion } from '@/pages/utils'
import lodash from 'lodash'

export default {
  name: 'PublicSwitchRegion',
  components: {
    HKLSelect,
  },
  setup () {
    const { allRegions, publicPathLastSelectedRegion } = useStoreGetters('regions', ['allRegions', 'publicPathLastSelectedRegion', 'regionLanguageMap'])
    const regionOpts = computed(() => {
      const allRegionValues = Object.values(unref(allRegions))
      const orderedRegions = lodash.orderBy(allRegionValues, 'order', 'asc')
      const currentDomain = window.location.origin
      const filteredRegions = orderedRegions.filter(region => (new URL(region.domain)).origin === currentDomain && region.name !== regionNames.global)
      return filteredRegions.map((item) => ({
        name: i18n.te(`regionOptions.${item.name}`) ? i18n.t(`regionOptions.${item.name}`) : item.displayName,
        value: item.name,
      }))
    })
    const selectedRegion = ref('')
    const { initRegionData, updatePublicPathLastSelectedRegion } = useStoreActions('regions', ['initRegionData', 'updatePublicPathLastSelectedRegion'])
    function initSelectedRegion () {
      const cachedSelectedRegion = unref(publicPathLastSelectedRegion).name
      const hasHK = unref(regionOpts).find(item => item.value === regionNames.HK)
      const fallbackRegion = hasHK ? regionNames.HK : unref(regionOpts)[0].value
      selectedRegion.value = cachedSelectedRegion || fallbackRegion
      switchRegion(selectedRegion.value)
    }
    function switchRegion (regionName) {
      const toUpdateRegion = unref(allRegions)[regionName]
      updatePublicPathLastSelectedRegion(toUpdateRegion)
      switchLangByRegion(regionName)
    }
    onMounted(async () => {
      await initRegionData(true)
      initSelectedRegion()
    })
    return {
      selectedRegion,
      regionOpts,
      initSelectedRegion,
      switchRegion,
    }
  },
}
</script>
